/*
 Created by CHT 2019/12/4 10:54
 筛选器（筛选控件）
*/

import BaseChart from "../BaseChart"
import {
  CHART_CATEGORY__FILTER,
  CHART_TYPE__FILTER_CONTROL,
} from "../types"
import context from '../../main.js'


class FilterControl extends BaseChart {
  constructor() {
    super()

    this.w = 20
    this.h = 4
    this.minW = 10
    this.minH = 3
    this.maxW = 30
    this.maxH = 15

    this.chartPropertiesHolder = {
      chartFilterMap: {
        /*
        "chartId":{
            "dataSourceType": "",
            "dataSourceId": "",
            "dataId": ""
        }
       */
      },
      filterGanged: [
        /*'chartId'*/
      ], // 筛选联动，依赖的筛选器Id。自己为「单数据源」时有此属性
      modify: 1, // 是否可以修改默认值
      fixedValue: 'fixed_value',
      method: "",   // 过滤方法
      value: [],     // 过滤值
      extValue: null
    }

    this.showPropertiesHolder = {
      showTitle: 1,
      // 筛选方式是否是选择值 0输入， 1选择
      filterWay: 1,
      // 第一个字段的 字段类型
      fieldType: '',
      // 只有一个字段时 用到的Id
      formId: '',
      dataId: '',
      filterFormId: '', // 如果筛选器关联多数据源，筛选器可以是下拉形式，但需要选择一个数据源表单
      openDynamicFilter: 'NO', //是否开启动态默认值
      dynFilter: {
        targetAppId: '',
        targetFormId: "",
        filterInfo: {
          relation: "and",
          jumpEmpty: 0,
          conditionList: []
        },
        sortList: [], //排序字段
        resultFieldId: "", // 提取字段 Id
      }
    }

    this.value = {
      fixedValue: 'fixed_value',
      method: "",
      value: [],
      extValue: null
    }
  }

  get title() {
    return this.chartName || FilterControl._title
  }

  set title(content) {
    this.chartName = content
  }
}


FilterControl._title = '筛选器'
FilterControl.type = CHART_TYPE__FILTER_CONTROL

FilterControl.prototype.chartCategory = CHART_CATEGORY__FILTER
FilterControl.prototype.chartType = FilterControl.type

FilterControl.prototype.getChartValue = async function () {
  if (this.showPropertiesHolder.openDynamicFilter === 'YES' &&
    this.showPropertiesHolder.dynFilter &&
    this.showPropertiesHolder.dynFilter.targetAppId &&
    this.showPropertiesHolder.dynFilter.targetFormId) {

    const res = await context.$store.dispatch('actionFilterFormMiddleData', this.showPropertiesHolder.dynFilter).catch(console.error)
    if (res && res.length && res[0].submitValue) {
      this.value.value.push(res[0].submitValue)
      this.chartPropertiesHolder.value.splice(0, this.chartPropertiesHolder.value.length, res[0].submitValue)
    }

  }
}
export default FilterControl
